<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.large {
      gap: utils.in_rem(16px);
    }
    &.medium {
      gap: utils.in_rem(12px);
    }
  }
</style>

<script>
  let cls = "";
  export { cls as class };
  export let gapSize = "large"; // "medium" | "large"
</script>

<div class="no-data {cls} {gapSize}">
  <slot name="icons" />
  <slot name="text" />
  <slot name="buttons" />
</div>
